import { createUseStyles } from 'react-jss';
import colors from "../../../utils/colors";

var styles = {
  productLinesSection: {
    paddingBottom: '1.5rem',
    borderBottom: "0.1rem solid ".concat(colors.neutral[300])
  },
  buttonsSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  },
  activeButton: {
    backgroundColor: colors.blue[100],
    borderColor: colors.blue[600]
  },
  activeAncillaryButton: {
    color: colors.blue[600]
  },
  inactiveButton: {
    color: colors.neutral[700],
    borderColor: 'transparent',
    '&:hover': {
      borderColor: colors.neutral[300]
    }
  },
  ancillaryDropdown: {
    color: colors.neutral[700],
    backgroundColor: colors.neutral[100],
    borderColor: colors.neutral[300]
  },
  button: {
    minWidth: '22rem',
    maxWidth: '22rem',
    height: '5rem',
    justifyContent: 'flex-start',
    textTransform: 'capitalize',
    fontSize: '1.8rem',
    fontWeight: 700,
    padding: '0 1.5rem',
    paddingRight: 0
  },
  ancillaryButton: {
    minWidth: '22rem',
    maxWidth: '22rem',
    minHeight: '5rem',
    height: 'auto',
    justifyContent: 'flex-start',
    textAlign: 'left',
    textTransform: 'capitalize',
    fontSize: '1.6rem',
    fontWeight: 700,
    padding: '0 1.5rem'
  },
  promt: {
    fontSize: '1.2rem',
    fontStyle: 'italic',
    color: colors.neutral[700],
    marginBottom: '1rem',
    marginTop: 0
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map